export const RESOURCE_TYPE_META: Record<
  string,
  { key: string; cssVar: string }
> = {
  COMPANIES: {
    key: 'resourceTypes.COMPANIES',
    cssVar: '--resource-companies',
  },
  DOCUMENTS: {
    key: 'resourceTypes.DOCUMENTS',
    cssVar: '--resource-documents',
  },
  CERTIFICATE: {
    key: 'resourceTypes.CERTIFICATE',
    cssVar: '--resource-certificate',
  },
  MEMBERSHIP: {
    key: 'resourceTypes.MEMBERSHIP',
    cssVar: '--resource-membership',
  },
  BADGE: { key: 'resourceTypes.BADGE', cssVar: '--resource-badge' },
  AUDITS: { key: 'resourceTypes.AUDITS', cssVar: '--resource-audits' },
  ASSESSMENTS: {
    key: 'resourceTypes.ASSESSMENTS',
    cssVar: '--resource-assessments',
  },
  TRACING: { key: 'resourceTypes.TRACING', cssVar: '--resource-tracing' },
  'SUPPLIER-NETWORK-SHARING': {
    key: 'resourceTypes.SUPPLIER-NETWORK-SHARING',
    cssVar: '--resource-network-sharing',
  },
  'RISK-ANALYSIS': {
    key: 'resourceTypes.RISK-ANALYSIS',
    cssVar: '--resource-risk-analysis',
  },
  CAPA: { key: 'resourceTypes.CAPA', cssVar: '--resource-capa' },
  QUESTIONNAIRES: {
    key: 'resourceTypes.QUESTIONNAIRES',
    cssVar: '--resource-questionnaires',
  },
  'CASCADE-MAPPING': {
    key: 'resourceTypes.CASCADE-MAPPING',
    cssVar: '--resource-cascade-mapping',
  },
  REPORTS: { key: 'resourceTypes.REPORTS', cssVar: '--resource-reports' },
  SLCP: { key: 'resourceTypes.SLCP', cssVar: '--resource-slcp' },
  'ENTITY-SCREENING': {
    key: 'resourceTypes.ENTITY-SCREENING',
    cssVar: '--resource-entity-screening',
  },
};
